export class BlogsController {
    constructor($scope, $rootScope, $location, $window, BlogService, UserService) {
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.location = $location;
        this.window = $window;
        this.UserService = UserService;
        this.BlogService = BlogService;

        this.init();
    }

    init() {
        this.scope.isLoadedPage = this.rootScope.content.location === this.location.path();
        this.scope.loading = false;
        this.scope.showVipModal = false;
        this.scope.createBlog = () => {
            if (this.rootScope.isVip() && this.rootScope.currentUserProfile.usertype === +'4') {
                this.window.location.href = '/blogrd/create-blog';
            } else {
                this.scope.showVipModal = true;
            }
        };
        this.scope.canLoadMore = () => {
            return this.rootScope.content.pageCount >= this.rootScope.content.page;
        };

        this.scope.loadMore = () => {
            this.loadMore();
        };


        if(this.rootScope.content.location !== this.location.path()) {
            this.rootScope.content.items = [];
            this.rootScope.content.page = 1;
            this.rootScope.content.pageCount = 0;
            this.rootScope.content.limit = 24;
            this.rootScope.content.maxItem = 0;
            this.rootScope.content.location = this.location.path();

            this.UserService.getCurrentUser()
                .then((response) => { let user = response.data;
                    if(!user.success) {  
                        this.rootScope.unregister = true
                    }
                    this.rootScope.currentUserProfile = user.data;
                })
                .catch((response) => { let err = response.data;
                    this.rootScope.unregister = true;
                    console.error(err);
                });

            this.loadMore();
        }
    }

    loadMore() {
        if(this.scope.loading) return;
        this.scope.loading = true;
        this.getBlogs(this.rootScope.content.page, this.rootScope.content.limit)
            .then((_res) => { let response = _res.data;
                this.rootScope.content.maxItem = response.itemCount;
                this.rootScope.content.pageCount = response.pageCount;
                this.rootScope.content.items = this.rootScope.content.items.concat(response.data);
                this.rootScope.content.items = _.uniqBy(this.rootScope.content.items, item => item._id);
                this.rootScope.content.page++;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
            })
            .catch((response) => { let err = response.data;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
                console.error(err);
            });
    }

    getBlogs(page, limit) {
        switch (this.location.path()) {
            case '/blogrd/miblog':
                return this.BlogService.getMyBlogs(page, limit);
            case '/blogrd/index/op/ranking':
                return this.BlogService.getBlogByRating(page, limit);
            case '/blogrd/index/op/me':
                return this.BlogService.getBlogsWithComments(page, limit);
            default:
                return this.BlogService.getBlogs(page, limit);
        }
    }
}
